// Generated by GitHub Copilot
import CompanyInvitation from '#core/entities/auth/companies/CompanyInvitation'
import { Type } from 'class-transformer'

/** Response from `POST /auth/company-invitations/` and resend — contains the invitation plus a one-time accept token. */
export default class CompanyInvitationIssue {
  @Type(() => CompanyInvitation)
  invitation: CompanyInvitation = new CompanyInvitation()
  accept_token: string = ''
}
